module.exports = __webpack_public_path__ + "static/kuruyemis-borsa-case-study-2e7c87d8392dfd8f3c695eb66c4d1566.webp";